import { useToast as usePrimeToast } from 'primevue/usetoast';

type Severity = 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast';

interface ToastOptions {
  summary: string;
  detail?: string;
  life?: number;
}

export function useToast() {
  const toast = usePrimeToast();
  const push = (severity: Severity, opts: ToastOptions): void => {
    toast.add({
      severity: severity === 'danger' ? 'error' : severity,
      summary: opts.summary,
      detail: opts.detail,
      life: opts.life ?? 5000,
    });
  };
  return {
    success: (opts: ToastOptions) => push('success', opts),
    info: (opts: ToastOptions) => push('info', opts),
    warn: (opts: ToastOptions) => push('warn', opts),
    danger: (opts: ToastOptions) => push('danger', opts),
  };
}
